import { withSearch } from "@elastic/react-search-ui";
import React, { useMemo } from "react";
import FilterRangeBar from "./FilterRangeBar.js";
import FilterSelectList from "./FilterSelectList.js";
import config from "../../../../config";
import { getParametricFacet } from "../../../config/faq-config-helper";
import ClearFilters from "../ClearFilters/ClearFilters";
import { useTranslation } from "react-i18next";
import "./Filter.css";

const parametricProductsConfigs = getParametricFacet();
const showQuickSearchFilterCounts = 5;

const toggleDetailedSearchFilters = () => {
  // Directly modify DOM state because parametricSearchElement is an external element, not managed by React.
  const parametricSearchElement = document.querySelector(
    ".p-parametric-search",
  );
  if (parametricSearchElement) {
    parametricSearchElement.classList.toggle("filter-showed");
  }
};

function Filter({ isLoading }) {
  const { t } = useTranslation();
  const quickSearchFilterConfigs = parametricProductsConfigs.slice(
    0,
    showQuickSearchFilterCounts,
  );
  const detailedSearchFilterConfigs = parametricProductsConfigs.slice(
    showQuickSearchFilterCounts,
    parametricProductsConfigs.length,
  );

  const getFilters = (filterConfigs) => {
    return (
      <>
        {filterConfigs.map((filterColumn, index) => {
          return (
            <div
              className="p-filter__box"
              style={{
                opacity: 1,
                maxHeight: "none",
                visibility: "visible",
                pointerEvents: isLoading ? "none" : "initial",
              }}
              key={index}
            >
              <p className="p-filter__header">{t(filterColumn.label)}</p>
              {filterColumn.filter?.type === "RangeBar" ? (
                <FilterRangeBar
                  show={1000}
                  key={index}
                  field={filterColumn.field}
                  label={t(filterColumn.label)}
                  options={filterColumn.filter.options}
                />
              ) : (
                <FilterSelectList
                  show={1000}
                  key={index}
                  field={filterColumn.field}
                  label={t(filterColumn.label)}
                />
              )}
            </div>
          );
        })}
      </>
    );
  };

  return (
    <>
      <div className="l-inner">
        <h1 className="c-title--main border">
          {t("Parametric search")} {t(config.parametricProduct)}
        </h1>
        <h2 className="c-title--subtitle">{t("Quick search")}</h2>
        <div className="p-filter">{getFilters(quickSearchFilterConfigs)}</div>

        {detailedSearchFilterConfigs.length !== 0 && (
          <>
            <div className="p-filter__detail">
              <h2 className="c-title--subtitle">{t("Advanced search")}</h2>
              <div className="p-filter">
                {getFilters(detailedSearchFilterConfigs)}
              </div>
            </div>
            <div className="p-button--toggle">
              <button onClick={toggleDetailedSearchFilters}>
                <span></span>
              </button>
            </div>
          </>
        )}

        <ClearFilters />
      </div>
    </>
  );
}

export default withSearch(({ isLoading }) => ({ isLoading }))(Filter);
